module.exports = __webpack_public_path__ + "img/Duration.8ca6a006.svg";